export default {
    setCurrentUser(state, payload) {
        state.currentUser = payload
    },
    setPassedUser(state, payload) {
        state.passedUser = payload
    }
}
